/**
 * Утилиты для работы с таймстампами
 */

/**
 * Получает таймстамп для первого дня текущего месяца
 * @returns {Object} - объект с секундами и наносекундами
 */
export function getFirstDayOfMonthTimestamp() {
  const now = new Date()
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
  const seconds = Math.floor(firstDay.getTime() / 1000)
  const nanos = (firstDay.getTime() % 1000) * 1e6

  return { seconds, nanos }
}

/**
 * Получает таймстамп текущего дня
 * @returns {Object} - объект с секундами и наносекундами
 */
export function getTodayTimestamp() {
  const now = new Date()
  const seconds = Math.floor(now.getTime() / 1000)
  const nanos = (now.getTime() % 1000) * 1e6
  return { seconds, nanos }
}

/**
 * Получает таймстамп для первого дня предыдущего месяца
 * @returns {number} - UNIX таймстамп в секундах
 */
export function getPreviousMonthFirstDayTimestamp() {
  const today = new Date()
  const firstDayOfPreviousMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  )
  return Math.floor(firstDayOfPreviousMonth.getTime() / 1000)
}

/**
 * Получает текущий таймстамп в секундах
 * @returns {number} - UNIX таймстамп в секундах
 */
export function getCurrentTimestampInSeconds() {
  return Math.floor(new Date().getTime() / 1000)
}

/**
 * Создает объект с диапазоном дат для запроса статистики
 * @returns {Object} - объект с полями from и to
 */
export function getStatisticsDateRange() {
  return {
    from: getPreviousMonthFirstDayTimestamp(),
    to: getCurrentTimestampInSeconds(),
  }
}
